module.exports = __webpack_public_path__ + "static/media/jetpure-5.08022023.jpg";